import { Component, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core';
import {  CandidateApi, CandidateProfile, DocumentType, DocumentInstructions, CandidateAdditionDocumentRequest, LookupField, LookupApi, SortParameters, CandidateGridInfo, FilterParams } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
 
import { LoaderService } from 'src/app/core/loader.service';
import { nullSafe } from 'src/app/utils';
import { LookupTypeKeys } from '../lookup-type-keys';
import { Observable } from 'rxjs';
import { CSVReportService } from 'src/app/core/csvreport.service';
import { finalize } from 'rxjs/operators';
import { CountryTypeIds,CountryTypesValues } from 'src/app/immigration/services/visatypes/country-types.enum';
import { DatePipe } from '@angular/common';
import { DialogService } from 'src/app/core/dialog.service';
import { StatusTypes } from '../status-types';

@Component({
  selector: 'eos-timeline-report',
  templateUrl: './timeline-report.component.html',
  styleUrls: ['./timeline-report.component.css']
})
export class TimelineReportComponent implements OnInit {
countries: LookupField[] = [];
pbStatuses: LookupField[] = [];
  officelocationCountryId:number| null = null;
  disableDownload = false;
sortParameters: SortParameters;
data: CandidateGridInfo;
daterange: string;
 dropdownSettings = {};
selectedPbStatuses = [];

   constructor(public modal: NgbActiveModal, 
    private candidateApi: CandidateApi,
    private common: CommonService,
    private loader : LoaderService,
    private toast: ToastService, 
    private lookupFieldService: LookupApi,
    private csvreportService: CSVReportService,
    private datePipe: DatePipe,
    private dialog: DialogService,
 ) {
  this.data= new CandidateGridInfo();
  this.data.sortParameters= new SortParameters();
  this.data.sortParameters.filterParams= new FilterParams();
  }

  ngOnInit(): void {

 this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'displayText',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getPbStatuses(),
    this.getCountries();
  }

  getPbStatuses() {
      const ob$ = this.lookupFieldService.getLookupTypeById(LookupTypeKeys.PREBOARDING_STATUS, undefined);
      ob$.subscribe(resp => {
        this.pbStatuses = resp.lookupFields.filter(item => item.id !== StatusTypes.DRAFT && item.id !== StatusTypes.CANCELLED && item.id !== StatusTypes.INVITED);
      });
      return ob$;
    }

    getCountries() {
    this.lookupFieldService.getLookupFieldsByType(27, 0, 0).subscribe(resp => {
      const cvalues = [new LookupField({ id: 0, displayText: 'All' })]
       cvalues.push(...resp.filter(country => country.id));
      this.countries = cvalues;
      
    });

    }

      openMod() {
      this.dialog.showDateRangeFilter(this.data.sortParameters.filterParams, (startDate: Date, endDate: Date) => {
      this.data.sortParameters.filterParams.startDate = startDate;
      this.data.sortParameters.filterParams.endDate = endDate;
      this.daterange = this.datePipe.transform(this.data.sortParameters.filterParams.startDate, 'dd-MMM-yy') + " - " + this.datePipe.transform(this.data.sortParameters.filterParams.endDate, 'dd-MMM-yy');
    });
  }

   clearDate() {
    this.daterange = null;
    this.data.sortParameters.filterParams.startDate = null;
    this.data.sortParameters.filterParams.endDate = null;
  }

    downloadTimelinereport() {
    //let countryValue = "";

  //if (this.countryId) {
    
    // switch (this.countryId) {
    //   case CountryTypeIds.SaudiArabia:
    //     countryValue = CountryTypesValues.SaudiArabia;
    //     break;
    //   case CountryTypeIds.UAE:
    //     countryValue = CountryTypesValues.UAE;
    //     break;
    //   case CountryTypeIds.BHR:
    //     countryValue = CountryTypesValues.BHR;
    //     break;
    //   case CountryTypeIds.KWT:
    //     countryValue = CountryTypesValues.KWT;
    //     break;
    //   case CountryTypeIds.OMN:
    //     countryValue = CountryTypesValues.OMAN;
    //     break;
    //   case CountryTypeIds.QAT:
    //     countryValue = CountryTypesValues.QAT;
    //     break;
    //   case CountryTypeIds.EGY:
    //     countryValue = CountryTypesValues.EGY;
    //     break;
    //   case CountryTypeIds.PAK:
    //     countryValue = CountryTypesValues.PAK;
    //     break;
    //   case CountryTypeIds.JOR:
    //     countryValue = CountryTypesValues.JOR;
    //     break;
    //   default:
    //     countryValue = "";
    // }

      let fileName = 'TMT Timeline report_';
     // this.data.sortParameters.filterParams.pbStatusIds = this.selectedPbStatuses.map((obj: any) => obj.id);

       this.disableDownload = true;
        this.csvreportService.downloadTimelineReport(this.officelocationCountryId,this.data.sortParameters.filterParams)
          .pipe(finalize(() => {
             this.disableDownload = false;
            // this.modal.close();
          })).subscribe(resp => {
            //const fileName = `${countryValue}_Timeline Report.xlsx`;
             fileName = fileName + (this.datePipe.transform(new Date(), 'dd-MMM-yy')) + ".xlsx";
            if ((window.navigator as any).msSaveOrOpenBlob) {
              (window.navigator as any).msSaveBlob(resp, fileName);
            } else {
              const url = window.URL.createObjectURL(resp);
              const a = document.createElement("a");
              document.body.appendChild(a);
              a.setAttribute("style", "display: none");
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            }
          });
    //  }
       }

      
  
}
